import { GROUPTYPES_CLASS, GROUPTYPES_GENERAL } from 'containers/User/constants.js';
import { MEMBERTYPE_ADMINGROUP, MEMBERTYPE_GROUP } from '../../constants.js';

// For SelectUsers
function selectOptions(roleType) {
  switch (roleType.id) {
    case MEMBERTYPE_GROUP:
      return {
        roles: [
          { id: GROUPTYPES_CLASS, name: 'classes' },
          { id: GROUPTYPES_GENERAL, name: 'general' },
        ],
        fetchOptions: {
          url: 'sa/groups',
          version: 2,
          typeField: 'groupType',
        },
        clientSearch: true,
      };
    case MEMBERTYPE_ADMINGROUP:
      return {
        roles: [roleType],
        noSearch: true,
        fetchOptions: {
          url: 'sa/administrativegroups',
          version: 2,
        },
        clientSearch: true,
      };
    default:
      return {
        roles: [roleType],
        fetchOptions: {
          url: 'sa/users',
          version: 2,
          typeField: 'type',
        },
      };
  }
}

export default selectOptions;
